// extracted by mini-css-extract-plugin
export default {"link":"VideoPopup_link__S3WAl"};